import React, { useEffect, useState } from 'react';
import type { CompeteFormComponent as CompeteFormComponentType } from '../schemas/components/compete-form.schemas';
import { usePageContext } from '../contexts/PageContext';
import { useStaticPageContext } from '../ssr/StaticPageContext';
import { sitesApi } from '../api/client';
import { isShareToken } from './CompeteForm/types';

interface CompeteFormComponentProps {
  component: CompeteFormComponentType;
}

export const CompeteFormComponent: React.FC<CompeteFormComponentProps> = ({ component }) => {
  const data = component.data;
  const staticCtx = useStaticPageContext();
  const { siteId } = usePageContext();
  const [origin, setOrigin] = useState(staticCtx.studioAppOrigin || '');

  useEffect(() => {
    if (origin || !siteId || typeof window === 'undefined') return;
    let cancelled = false;
    sitesApi
      .getStudioCaptureForms(siteId)
      .then(result => {
        if (!cancelled && result.studioAppOrigin) setOrigin(result.studioAppOrigin);
      })
      .catch(() => {
        /* preview stays as the form name */
      });
    return () => {
      cancelled = true;
    };
  }, [origin, siteId]);

  if (!isShareToken(data.shareToken)) {
    if (typeof window === 'undefined') return null;
    return (
      <section className="py-12 px-4 text-center text-sm text-gray-500">
        Select a Compete Studio form
      </section>
    );
  }

  if (typeof window === 'undefined') {
    return (
      <section
        className="compete-form-component"
        data-widget="compete-form"
        data-share-token={data.shareToken}
        data-studio-origin={staticCtx.studioAppOrigin || ''}
        data-desktop-height={String(data.desktopHeight)}
        data-mobile-height={String(data.mobileHeight)}
        data-form-name={data.formName}
      />
    );
  }

  if (!origin) {
    return (
      <section className="py-12 px-4 text-center text-sm text-gray-600">
        {data.formName || 'Compete Studio form'}
      </section>
    );
  }

  const src = `${origin.replace(/\/$/, '')}/forms/${data.shareToken}?embed=iframe`;

  return (
    <section className="compete-form-component">
      <iframe
        title={data.formName || 'Form'}
        src={src}
        style={{
          width: '100%',
          border: 0,
          display: 'block',
          height: data.desktopHeight,
        }}
      />
    </section>
  );
};
